import selectPagedDirective from './selectPagedDirective';

export default angular.module('relayComps.selectPaged', []).directive('selectPaged', selectPagedDirective).name;
